import { useCallback, useMemo, useState } from "react";
import { atomWithStorage } from "jotai/utils";
import { useAtom } from "jotai";

const defaultLimit = 10;
const minLimit = 1;

const limits = atomWithStorage<Record<string, number | undefined>>("pagination.limits", {
  "": defaultLimit,
});

export function usePagination(settingsKey = "", defaultValue: number | undefined = undefined) {
  const [offset, setOffset] = useState(0);
  const [storedLimits, setStoredLimits] = useAtom(limits);

  const limit = useMemo(
    () => storedLimits[settingsKey] ?? defaultValue ?? storedLimits[""] ?? defaultLimit,
    [settingsKey, storedLimits, defaultValue]
  );

  const loadMore = useCallback(() => {
    setOffset((prev) => prev + limit);
  }, [limit]);

  const setLimit = useCallback(
    (newLimit: number | undefined) => {
      setStoredLimits((prev) => ({ ...prev, [settingsKey]: newLimit === undefined ? undefined : Math.max(newLimit, minLimit) }));
    },
    [settingsKey, setStoredLimits]
  );

  return {
    offset,
    setOffset,
    limit,
    setLimit,
    loadMore,
  };
}
